module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "parse-btn btn btn-info sq",
    style: (_vm.styles.csv),
    attrs: {
      "disabled": _vm.disabled,
      "id": _vm.id + 'button-csv'
    },
    on: {
      "click": _vm.downloadCSV
    }
  }, [_vm._t("csv"), _vm._v(" "), (!_vm.csvSlotInUse) ? _c('span', [_vm._v("To CSV")]) : _vm._e()], 2), _vm._v(" "), _c('button', {
    staticClass: "parse-btn btn btn-info sq",
    style: (_vm.styles.xlsx),
    attrs: {
      "disabled": _vm.disabled,
      "id": _vm.id + 'button-xlsx'
    },
    on: {
      "click": _vm.downloadXLSX
    }
  }, [_vm._t("xlsx"), _vm._v(" "), (!_vm.xlsxSlotInUse) ? _c('span', [_vm._v("To XLSX")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-121615b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/helpers/ParseFromJson.vue
// module id = 2095
// module chunks = 1